import { convertValidationRules } from '../../hooks/useFormState';
import { isValidEmail, validateAccountNumber, validateEmail } from '../../util/form-validation';
import { FORM_TYPE } from './Form';

type AdditionalContext = {
  content: Map<string, string>;
  params?: any;
  applyingFor?: string;
};

export type IQBDModel = {
  annualIncome?: string;
  confirmAnnualIncome?: Boolean;
  ethinicity?: string;
  otherEthnicity?: string;
  fixedIncome?: string;
  houseHoldSize?: number;
  paperless?: Boolean;
  prefLanguage?: string;
  signature?: string;
  address?: string;
  accountNumber?: string;
  customerFirstName?: string;
  customerLastName?: string;
  customerEmail?: string;
  customerRelType?: string;
  loggedInAccountNumber?: string;
  applicantLastName?: string;
  applicantFirstName?: string;
  applicantEmail?: string;  
  applicantPhone?: string;
};

export const iqbdFormValidateFunction = () =>
  convertValidationRules<IQBDModel, AdditionalContext>(context => {
    const { values, content, applyingFor } = context;

    const isOther = applyingFor === FORM_TYPE.Other;
    const isPublic = applyingFor === FORM_TYPE.Public;
    console.log(values);
    return {
      annualIncome: () =>
        !values.annualIncome 
          ? content.get('FIELD_IS_REQUIRED')
          : null,
      otherEthnicity: () =>
        values.ethinicity === content.get('OTHER')
          ? values.otherEthnicity?.trim().length
            ? null
            : content.get('FIELD_IS_REQUIRED')
          : null,
      fixedIncome: () =>
        !values.fixedIncome?.trim()
          ? content.get('UNSELECTED_FIXED_INCOME_ERROR')
          : null,
      houseHoldSize: () =>
        !values.houseHoldSize
          ? content.get('UNSELECTED_HOUSEHOLD_SIZE_ERROR')
          : null,
      paperless: () =>
        values.paperless === null || values.paperless === undefined
          ? content.get('FIELD_IS_REQUIRED')
          : null,
      prefLanguage: () =>
        !values.prefLanguage?.trim() ? content.get('FIELD_IS_REQUIRED') : null,
      confirmAnnualIncome: () =>
        !values.confirmAnnualIncome ? content.get('FIELD_IS_REQUIRED') : null,
      signature: () =>
        !values.signature?.trim() ? content.get('BLANK_NAME_ERROR') : null,
      accountNumber: () =>
        (isPublic || isOther)
          ? validateAccountNumber(values.accountNumber)
          : null,
      address: () =>
        (isPublic || isOther) && !values.address?.trim()
          ? content.get('FIELD_IS_REQUIRED')
          : null,
      customerFirstName: () =>
        (isPublic || isOther) && !values.customerFirstName?.trim()
          ? content.get('FIELD_IS_REQUIRED')
          : null,
      customerLastName: () =>
        (isPublic || isOther) && !values.customerLastName?.trim()
          ? content.get('FIELD_IS_REQUIRED')
          : null,
      customerEmail: () => {
        if ((isPublic || isOther) && values.customerEmail?.trim()) {
          const emailError = !isValidEmail(values.customerEmail);
          console.log('emailError', emailError);
          return emailError ? content.get('ERROR_AUTH_BAD_EMAIL') : null;
        }
        return null;
      },
      customerRelType: () =>
        (isPublic || isOther) && !values.customerRelType?.trim()
          ? content.get('FIELD_IS_REQUIRED')
          : null,
      applicantFirstName: () =>
        (isPublic) && !values.applicantFirstName?.trim()
          ? content.get('FIELD_IS_REQUIRED')
          : null,  
       applicantLastName: () =>
        (isPublic) && !values.applicantLastName?.trim()
          ? content.get('FIELD_IS_REQUIRED')
          : null,  
      applicantEmail: () => {
        if (isPublic && values.applicantEmail?.trim()) {
          const emailError = validateEmail(values.applicantEmail);
          return emailError ? emailError : null;
        }
        return null;
      }
    };
  });
